module.exports = "<div class=\"no_recommended_content_label\">{{noRecommendedContent}}</div>";